export const enCustom = {
    headlines: {
        loginEmail: "Sign in or create account",
        loginEmailNoSignup: "Sign in or create account",
        mfaSetUp: "Extra security is optional",
        registerAuthenticator: "Passkey is optional",
        signIn: "Sign in or create account",
        signUp: "Start by entering your email",
        setupLoginMethod: "Choose a sign-in method",
    },
    texts: {
        enterPasscode: "Enter the one-time code sent to your email. Please also check your spam folder.",
        enterPasscodeNoEmail: "Enter the one-time code sent to your primary email. Please also check your spam folder.",
        mfaSetUp: "You can enable MFA now or skip this and set it up later from settings.",
        selectLoginMethodForFutureLogins: "You can choose a sign-in method now or skip this and finish your profile first.",
        setupPasskey: "You can create a passkey for faster sign-in, or skip this and enable it later from settings. Biometric data stays only on your devices.",
    },
    labels: {
        skip: "Skip for now",
    },
};
